import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { SeparationModuleService } from '../separation-module.service';
import { CommonService } from '../Model/Common/common.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-separation-policy-view',
  standalone: true,
  imports: [CommonModule, LoaderComponent, RouterModule, DataTablesModule],
  templateUrl: './separation-policy-view.component.html',
  styleUrl: './separation-policy-view.component.scss'
})
export class SeparationPolicyViewComponent {

  isDisabled: boolean = false;
  LeaveData: any[] = [];
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};

  constructor(
    private separation: SeparationModuleService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private download: DownloadSampleService,
    private toast: ToastService
  ) {
    // this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.SeparationPolicyGet();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  SeparationPolicyGet() {
    this.isDisabled = true;
    this.separation.SeparationRuleLoad({ SelectType: 1, ESS_SeparationRuleID: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.TableDatas.forEach((element:any) => {
          element.WebESSApplicability = response.Table1.filter((e:any) => e.ESS_SeparationRuleId == element.ESS_SeparationRuleId)[0].ApplicabilityName
        });
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  exportToExcel(){
    if(this.TableDatas.length == 0){
      this.toast.show({message: 'No data found', type: toastTypeEnum.warning});
      return;
    }else{
      this.download.exportToExcelWithProgress(this.TableDatas, 'Separation Policies');
    }
  }

}
